/* Header background color */
export const BACKGROUND_HEADER = 'rgb(111, 111, 111, 0.75)';
export const BACKGROUND_COLOR = 'rgb(250, 250, 250)';
export const PRIMARY_COLOR = 'rgb(42, 107, 183)';
export const PRIMARY_COLOR_HIGHLIGHT = 'rgb(9, 62, 125)';

export const SECONDARY_COLOR = 'rgb(224, 225, 226)';
export const SECONDARY_COLOR_HIGHLIGHT = 'rgb(202, 203, 205)';

export const BLACK_COLOR = 'rgb(0, 0, 0)';
export const WHITE_COLOR = 'rgb(255, 255, 255)';

export const ICON_COLOR = 'rgb(85, 85, 85)';
export const ICON_COLOR_INVERTED = SECONDARY_COLOR;

export const FEEDBACK_COLOR = 'rgb(255, 172, 41)';
export const FEEDBACK_COLOR_INVERTED = WHITE_COLOR;

export const ALARM_COLOR = 'rgb(189, 0, 0)';
export const ALARM_COLOR_INVERTED = SECONDARY_COLOR;

export const WARNING_COLOR = 'rgb(255, 172, 41)';

export const POSITIVE_COLOR = 'rgb(0, 165, 80)';
export const POSITIVE_COLOR_INVERTED = SECONDARY_COLOR;

export const DISABLE_COLOR = SECONDARY_COLOR_HIGHLIGHT;
